import { PromocodesTableColumnsIntl } from 'types/i18n';

export const promocodesTableColumnsDictionaryRu: PromocodesTableColumnsIntl = {
  id: 'id',
  value: 'Промокод',
  org: 'Организация',
  person: 'ФИО',
  createdAt: 'Создан',
  status: 'Статус',
  activatedAt: 'Активирован',
  expiresAt: 'Действует до',
  statusValueText(promocode) {
    if (promocode.activatedBy === 'CLIENT') {
      return 'Клиент';
    }

    if (promocode.activatedBy === 'PARTNER') {
      return 'Партнер';
    }

    return 'Активен';
  },
  promocodeValueText(promocode) {
    return promocode.value.split('').reduce((acc, char, index) => {
      return `${acc}${char}${index === 2 ? ' ' : ''}`;
    }, '');
  },
};
